import { CommonModule } from '@angular/common';
import { Component, HostListener, ViewChild } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { NavigationEnd, Router } from '@angular/router';
import { AnyType } from '@thehubz/shared/model';

const CSS_VISIBLE_CLASS = 'mobile-nav-visible';

@Component({
  selector: 'sp-mobile-navigation',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './mobile-navigation.component.html',
  styleUrls: ['./mobile-navigation.component.scss'],
})
export class MobileNavigationComponent {
  @ViewChild('mobileNavRef') mobileNavRef: AnyType;
  @ViewChild('toggleButtonRef') toggleButtonRef: AnyType;

  isVisible = false;

  constructor(private router: Router) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.isVisible = false;
      }
    });
  }

  show(): void {
    this.isVisible = true;
    document.body.classList.add(CSS_VISIBLE_CLASS);
    this.mobileNavRef?.nativeElement?.focus();
  }

  hide(): void {
    this.isVisible = false;
    document.body.classList.remove(CSS_VISIBLE_CLASS);
    this.toggleButtonRef?.nativeElement?.focus();
  }

  onToggle(): void {
    if (this.isVisible) {
      this.hide();
    } else {
      this.show();
    }
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Escape' || event.code === 'Escape') {
      this.hide();
    }
  }
}
